<template>
  <div class="blockly">
    <div id="blocklyDiv"></div>


    <!-- 模块列表，带分组 -->
    <xml xmlns="https://developers.google.com/blockly/xml" id="toolbox" style="display: none">
    <category name="D" id="motLabel"  expanded="true" colour="%{BKY_MATH_HUE}">
        <!--行走-->
       <block type="dev_step">
        <value name="step">
          <block type="math_number">
            <field name="NUM">1</field>
          </block>
        </value>
        </block>
        <sep gap="5"></sep>
        <!-- <sep gap="5"></sep>
        <block type="dev_turn_left"></block>-->
        <sep gap="5"></sep>

        <!--右转-->
        <block type="dev_turn_right"></block>
        <sep gap="5"></sep>
        <!--飞船前进-->
        <block type="airship_step">
          <value name="step">
            <block type="math_number">
              <field name="NUM">1</field>
            </block>
          </value>
        </block>

        <sep gap="5"></sep>
        <!--飞船右转-->
        <block type="airship_turn_right"></block>
        <sep gap="5"></sep>
        <block type="window_wait"></block>

    </category>
    <category name="C"  id="conLabel"  colour="%{BKY_LOOPS_HUE}">
      
        <!--重复执行-->
        <block type="controls_repeat_ext">
          <value name="TIMES">
            <block type="math_number">
              <field name="NUM">4</field>
            </block>
          </value>
        </block>

        <sep gap="5"></sep>

        <block type="controls_if"></block>
        <sep gap="5"></sep>

        <!-- <block type="controls_whileUntil"></block> -->

        <block type="logic_compare"></block>
        <sep gap="5"></sep>
        <block type="logic_operation"></block>
    </category>
    <category name="V" id="numLabel"  colour="%{BKY_VARIABLES_HUE}">

        <block type="variables_set">
          <field name="VAR">a</field>
        </block>
        <sep gap="5"></sep>
        <block type="variables_set">
          <field name="VAR">b</field>
        </block>

        <sep gap="5"></sep>
        <block type="math_change">
          <field name="VAR">a</field>
        </block>
        <sep gap="5"></sep>
        <block type="math_change">
          <field name="VAR">b</field>
        </block>
                <!--数字-->
        <block type="math_number">
          <field name="NUM">1</field>
        </block>
        
        <sep gap="5"></sep>
        <block type="variables_get">
          <field name="VAR">a</field>
        </block>
        <sep gap="5"></sep>
        <block type="variables_get">
          <field name="VAR">b</field>
        </block>
        <sep gap="5"></sep>
        <block type="math_arithmetic">
          <value name="A">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
          <value name="B">
            <shadow type="math_number">
              <field name="NUM">1</field>
            </shadow>
          </value>
        </block>
        
       
      </category>
      <category name="F" id="funLabel" custom="PROCEDURE" colour="%{BKY_PROCEDURES_HUE}">
      </category>
    </xml>

      <!-- 以色列新增WhatsApp求组按钮-->
    <!-- <div class='whatsapp' v-show="$i18n.locale == 'he'">
      <div class='whatsapp_button' 
        :style="{backgroundImage: 'url('+createURL+'/static/images/WhatsApp.png)',backgroundSize:'contain'}"
        onclick="window.open('https://wa.me/+972533511154','mywindow');" style="cursor: pointer;"
        ></div>
      <p dir="auto" class="whatsapp_tip">{{ $t("need_help") }}</p>
    </div> -->

    <div class='audioBlockly' v-show="audioOpenShow" :style="{backgroundImage: 'url('+createURL+'/static/images/audio/' + lang + '/sign03.png)',backgroundSize:'contain'}"></div>
    <div class="blocklyP">
      <div
        class="blocklyR"
      >

        <div class="runCode" @click="runCode()"></div>

        <div
          class="openAudio"
          ref="audio01"
          :style = "{ background: `url(${IMG_BASE_URL}blockly/audio02.png)`}"
          @click="checkAudioOpen()"
          v-show="!blocklyAudioShow"
        ></div>
        <div
          class="openAudio"
          ref="audio02"
          :style = "{ background: `url(${IMG_BASE_URL}blockly/audio01.png)`}"
          @click="checkAudioClose()"
          v-show="blocklyAudioShow"
        ></div>
        <div
          class="resetBtn"
          ref="blocklyQuestionMark"
          @click="resetCodeHandler"
          :style = "{ background: `url(${IMG_BASE_URL}blockly/block_reset.png)`}"
        ></div>
        <div
          class="opreate01"
          ref="blocklyQuestionMark"
          @click="checkImg"
          :style = "{ background: `url(${IMG_BASE_URL}blockly/op01.png)`}"
        ></div>
      </div>
      <div class="blocklyC">
        <span v-if="$i18n.locale=='he'" style="direction:rtl">{{blocklyText.he}}</span>
        <span v-else>{{blocklyText[$i18n.locale] || blocklyText.en || blocklyText.zh }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import store from "../../store";
import { mapGetters } from "vuex";
import AdventureManager from "../../manager/AdventureManager";
import { loadScriptsInOrder } from "../../utils/loadScript";


export default {
  data() {
    return {
      blocklyAudioShow: false,
      runShow: true,
      createURL: process.env.GAME_CREATE_URL,
      IMG_BASE_URL: process.env.IMG_BASE_URL,
      startScale: 1.,
      maxScale: 2.0,
      minScale: 0.5,
      audioOpenShow: localStorage.getItem("audioOpenShow") == false ? false : true,
      lang: localStorage.getItem("language"),
    };
  },
  async mounted() {
    // 自定义方法挂载全局 方便测试使用
    window["test_show_blockly"] = (data = '') => {
      AdventureManager.toFront_importCode(data)
    };

    console.log("Loading Blockly workspace");

    let lang = AdventureManager.getLanguage();
    this.$i18n.locale = lang;

    const scriptList = [
        "./static/js/blockly/11.1.1/blockly_compressed.js",
        "./static/js/blockly/11.1.1/blocks_compressed.js",
        "./static/js/blockly/11.1.1/javascript_compressed.js", // 用JavaScript来跑
        "./static/js/blockly/11.1.1/python_compressed.js",      // 用Python计算行数
        "./static/js/blockly/11.1.1/icode_blocks.js",
        "./static/js/blockly/continuous-toolbox/6.0.7/index.js",
    ];

    if (lang.slice(0, 2) == "en") {//如果是英文则引用英文的js文件
        scriptList.push("./static/js/blockly/en.js");
    } else if(lang == "he") {
        scriptList.push("./static/js/blockly/he.js");
      } else if(lang == "vi") {
        scriptList.push("./static/js/blockly/vi.js");
    } else {
        scriptList.push("./static/js/blockly/zh.js");
    }
    await loadScriptsInOrder(scriptList);

    let workspace = Blockly.inject("blocklyDiv", {
      media: "../../../static/media/",
      plugins: {
        toolbox: ContinuousToolbox,
        flyoutsVerticalToolbox: ContinuousFlyout,
        metricsManager: ContinuousMetrics,
      },
      toolbox: document.getElementById('toolbox'),
      zoom: {
        controls: true,
        wheel: false,
        startScale: this.startScale,
        maxScale: this.maxScale,
        minScale: this.minScale,
        scaleSpeed: 1.1
      },
      grid: { spacing: 20, length: 3, colour: "#ccc", snap: true }, //网格模式
      trashcan: true,
      scrollbars: true,
      comments: true
    });
    store.state.Workspace = workspace;
  
    workspace.scrollCenter()

  },
  
  methods: {

    resetCodeHandler(){
      store.state.toBack = true;
      store.state.skipStyleShow = false
      AdventureManager.sendToGame("showResetCodeDialog");
    },

    runCode() {
      // 检查是否嵌套太多
      let list = store.state.Workspace.getTopBlocks();
      for(var i=0;i<list.length;i++){
        this.checkIsMax({"block":list[i],"len":0});
      }

      this.audioOpenShow = false;
      localStorage.setItem("audioOpenShow", false);

      if(window._code_is_running) return;

      AdventureManager.getWorkspaceCode();

      window.LoopTrap = 1000;
      Blockly.JavaScript.INFINITE_LOOP_TRAP =
        'if (--window.LoopTrap == 0) throw "Infinite loop.";\n';

      var code = Blockly.JavaScript.workspaceToCode(store.state.Workspace);
   
      window._code_is_running = true;
      AdventureManager.updateCurrentCodeLines(); // 记录下行数
      AdventureManager.setWorkspaceDeletable(false);

      window.bridge.clearCurrentSteps();
      Blockly.JavaScript.INFINITE_LOOP_TRAP = null;


      // 2023-06-15 magic, 去掉自动初始化为0的代码
      code = code.replace(/^var (.*);/g, "let $1 = NaN;"); //定义变量为未定义状态
      // code = code.replace(/\(typeof .* == 'number' \? /g, "").replace(/ : 0\)/g, ""); // 取消默认判断

      try {
        eval(code);
      } catch (e) {
        if(this.$i18n.locale == "zh") {
          let alertInfo;
          if(e.name == "ReferenceError" && e.message.match(/is not defined/)){
            alertInfo = "引用错误：" + e.message.replace("is not defined", "未定义的变量");
          }
          if(e.name == "Error" && e.message.match(/Value must be number/)){
            alertInfo = "错误：移动的步数必须为数值\n (请检查是否有未定义的变量)";
          }
          if(e.name == "TypeError" && e.message.match(/Cannot read properties of null/)) {
            alertInfo = "错误：无法找到可以操作的对象（检查是否错误使用了飞船积木块）";
          }
          // alert(alertInfo);
          console.log(e);
          AdventureManager.toFront_showPopboardFail({title: "错误", txt: alertInfo});
        } else {
          alert(e);
        }

        window._code_is_running = false;
        AdventureManager.setWorkspaceDeletable(true);
        return;
      }


      window.bridge.onRunCodeButtonClick();
    },

    checkIsMax(parentBlock){
      if(parentBlock.len>12){
        alert("嵌套太多");
        throw new Error("嵌套太多");
      }
      let list = parentBlock.block.getChildren();
      for(var i = 0;i<list.length;i++){
        if(list[i]==parentBlock.block.getNextBlock()){
          this.checkIsMax({"block":list[i],"len":0})
          continue;
        }
        this.checkIsMax({"block":list[i],"len":parentBlock.len+1});
      }
    },
   
    runCodeShow(flag) {
      this.runShow = flag;
    },
    // 开关背景音乐
    checkAudioOpen() {
      this.blocklyAudioShow = true;
      window.bridge.toggleMusic(1);
    },
    checkAudioClose() {
      this.blocklyAudioShow = false;
      window.bridge.toggleMusic(0);
    },


    checkImg() {
      // do nothing
    },
  },
  computed: {
    ...mapGetters(["Workspace", "allImageMap", "lang", "blocklyText"])
  }
};
</script>
<style scoped>
.blockly {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  font-size: 20px;
  position: relative;
  background: #fff4e5;
  top: 0;
}

#blocklyDiv {
  width: 100%;
  height: 100%;
  position: absolute;
}

.blocklyP {
  height: 150px;
  width: 100%;
  position: fixed;
  bottom: 0px;
  left: 0px;
  overflow: hidden;

  background-image:
    url("../../../static/images/blockly/blocklyR0.png"),
    url("../../../static/images/blockly/blocklyR.png"),
    url("../../../static/images/blockly/blocklyC.png"); 
  background-repeat: no-repeat, no-repeat, repeat-x;
  background-position:
    left,
    right,
    center;
}

.blocklyP .blocklyR {
  width: 274px;
  height: 100%;
  position: absolute;
  right: 0;
}

.blocklyC {
  position: absolute;
  left: 33px;
  right: 272px;
  font-size: 20px;
  color: #fff;
  padding: 25px 20px;
  line-height: 25px;
  min-width: 100px !important;
}

.blocklyC span {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.runCode {
  position: absolute;
  width: 162px;
  height: 60px;
  left: 68px;
  top: 22px;
  cursor: pointer;
  background: url("../../../static/images/blockly/run01.png") no-repeat;
}
.runCode:hover {
  background: url("../../../static/images/blockly/run02.png") no-repeat;
}

.openAudio {
  position: absolute;
  width: 42px;
  height: 42px;
  left: 74px;
  top: 88px;
  cursor: pointer;
  transition: all 0.3s ease-in-out 0s;
  transform: scale(1);
}

.resetBtn {
  position: absolute;
  width: 42px;
  height: 42px;
  right: 103px;
  top: 88px;
  cursor: pointer;
  transition: all 0.3s ease-in-out 0s;
  transform: scale(1);
}

.opreate01 {
  position: absolute;
  width: 42px;
  height: 42px;
  right: 49px;
  top: 88px;
  cursor: pointer;
  transition: all 0.3s ease-in-out 0s;
  transform: scale(1);
}

.resetBtn:hover,
.resetBtn:hover,
.openAudio:hover,
.opreate01:hover {
  transform: scale(1.1);
}

.audioBlockly{
  position:absolute;
  bottom:0px;
  right: 70px;
  width: 150px;
  height: 162px;
  z-index:91111;
  animation: firstdiv .5s linear .5s infinite alternate;
}
</style>


// WEBPACK FOOTER //
// src/components/onlineClass/blockly.vue